module.exports = __webpack_public_path__ + "static/img/gaozhongshuxue.099da64c.jpg";